module.exports = __webpack_public_path__ + "static/media/SFProText-Regular.ce45a9a9.ttf";